module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS7.fce17c85.jpg";